export function extractLastPathFromUrl(input: string): string {
  const value = input.trim();

  if (!value) {
    return '';
  }

  try {
    const url = new URL(value);
    const lastPathSegment = getLastNonEmptySegment(url.pathname);

    return lastPathSegment || value;
  } catch {
    if (!value.includes('/')) {
      return value;
    }

    const pathWithoutQuery = value.split(/[?#]/, 1)[0];
    const lastPathSegment = getLastNonEmptySegment(pathWithoutQuery);

    return lastPathSegment || value;
  }
}

function getLastNonEmptySegment(path: string): string {
  return (
    path
      .split('/')
      .filter((segment) => segment.length > 0)
      .at(-1) || ''
  );
}
